module.exports = __webpack_public_path__ + "img/A_ezplan1.9abde631.png";